// @flow

import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class TaskTicketLinkServiceResource extends NestedResource {
    basePath: string = 'project_management/tasks/{parent}/link_service/';

    objectPath: string = 'project_management/tasks/{parent}/link_service/{ident}/';

    wfServices(parentId: string, query: Object = {}): Promise<Object> {
        const servicesPath = `${this._getBasePath(parentId)}wf_services/`;
        return this.client._request(servicesPath, 'GET', query).then((response) => response.data);
    }
}
